/* eslint-disable jsx-a11y/anchor-is-valid */
import Axios from "axios";
import React, { useState, useContext } from "react";
import { FormattedMessage } from "react-intl";
import Button from "../../UI/Button";
import { Modal } from "../../UI/modal";
import { useParams } from "react-router-dom";
import PriceModal from "./modal/PriceModal";
import { VoteMomoModal } from "./modal/VoteMomoModal";
import styled from "styled-components";
import { ContestantsContext } from "../../../App";
import { getDetailImage } from "../../../libs";
import { TABLE_MAP } from "../../../config/variables";

export const formatNumber = (num, decimal) =>
  Number(num || 0).toLocaleString("de-DE", {
    maximumFractionDigits: decimal || 0,
  });

const comboArr = [
  { display: "20 ⭐", value: 1 },
  { display: "200 ⭐", value: 2 },
  { display: "600 ⭐", value: 3 },
  { display: "1050 ⭐", value: 4 },
  { display: "2200 ⭐", value: 5 },
];

const ContestantDetail = (props) => {
  const contestant = props.contestant;
  const time = props.time;
  const [payUrl, setPayUrl] = useState("");
  const [combo, setCombo] = useState(0);
  const [isOpen, setOpen] = useState(false);
  const [isOpenPrice, setOpenPrice] = useState(false);

  const { missId, table } = useParams();

  const onHandleVote = async (combo, gateway) => {
    try {
      const res = await Axios.get(`/api/${gateway}/${missId}/${combo}`);
      console.log("ressss", res);
      setPayUrl(res.data.payUrl);
      setCombo(combo);
      setOpen(true);
    } catch (error) {
      console.log("error when get pay Url", error.message);

      setPayUrl("");
      setCombo(combo);
      setOpen(true);
    }
  };

  // const isVoteTime = true;
  const isVoteTime =
    time.now >= time.start && time.now <= time.end ? true : false;

  const { contestants } = useContext(ContestantsContext);

  const tableContestants =
    contestant && contestants[`rank${table}`]
      ? contestants[`rank${table}`]
      : null;

  const totalVote =
    tableContestants?.find((con) => con.contestantId == missId)?.totalPoint ||
    "0";

  const totalStar =
    tableContestants?.find((con) => con.contestantId == missId)?.totalStar ||
    "0";

  const totalStarAA =
    tableContestants?.find((con) => con.contestantId == missId)?.totalStarAA ||
    "0";

  const getInfo = (key) => contestant.info && contestant.info[key];
  // const getEmbedLink = (link) => {
  //   if (link) {
  //     const id = link.split(".be/")[1];

  //     const e = `https://www.youtube.com/embed/${id}`;

  //     return e;
  //   }
  // };

  let votePoint = Number(totalStar) / 2000;
  votePoint = votePoint > 100 ? 100 : votePoint;
  return (
    <Styles className="bs-row row-sm-15" id="contestant-detail">
      <div className="bs-col md-55-15">
        <div className="detail-left">
          <div className="video">
            <div className="video-content">
              {/* <video width="100%" height="auto" controls></video> */}

              {/* <iframe
                src={getEmbedLink(getInfo("link"))}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe> */}
              <img
                src={getDetailImage(contestant.code)}
                alt={contestant.code}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bs-col md-45-15">
        <div className="detail-right">
          <div className="slide-detail">
            <div className="slide-item">
              <div className="item">
                <div className="text">
                  <div className="category-text">
                    Hạng mục: {TABLE_MAP[table]}
                  </div>
                  <p className="contestant-name">{contestant.fullname}</p>
                  <div className="total-vote">
                    <div className="vote-number-1">
                      {formatNumber(totalStar)} ⭐️
                    </div>
                    <div className="vote-number-2">
                      Bvote: <span>{formatNumber(totalVote)}</span>
                    </div>
                    <div className="vote-number-2">
                      AvatarArt: <span>{formatNumber(totalStarAA)}</span>
                    </div>
                    <div className="vote-number-2">
                      Điểm quy đổi: <span>{formatNumber(votePoint, 2)}</span>
                    </div>
                  </div>
                  <div className="sub-text">
                    {table === "6" || table === "7"
                      ? "Thành tích nổi bật"
                      : "Giới thiệu"}
                  </div>
                  <p
                    className="content-text"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {getInfo("intro")}
                  </p>
                  {/* <div className="info">
                    <div className="info-item">
                      <span>Định dạng: </span>Streaming
                    </div>
                    <div className="info-item">
                      <span>Thể loại: </span>Electropop
                    </div>
                    <div className="info-item">
                      <span>Thời lượng: </span>4:04
                    </div>
                  </div> */}
                  <div className="detail-button">
                    <Button
                      className="vote_dropdown open-modal"
                      onClick={() => setOpenPrice(true)}
                      secondary
                    >
                      Xem quy đổi điểm bình chọn
                    </Button>

                    {isVoteTime && (
                      <Button className="vote_dropdown">
                        Bình chọn qua Momo
                        <div className={`dropdown`}>
                          <ul>
                            {comboArr.map((combo, ind) => (
                              <li
                                key={ind}
                                onClick={() => {
                                  onHandleVote(combo.value, "momo");
                                }}
                              >
                                {/* {combo} vote{combo > 1 ? "s" : ""} */}
                                {combo.display}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Button>
                    )}

                    {isVoteTime && (
                      <Button className="vote_dropdown">
                        Bình chọn qua ngân hàng, thẻ...
                        <div className={`dropdown`}>
                          <ul>
                            {comboArr.map((combo, ind) => (
                              <li
                                key={ind}
                                onClick={() => {
                                  onHandleVote(combo.value, "appota");
                                }}
                              >
                                {/* {combo} vote{combo > 1 ? "s" : ""} */}
                                {combo.display}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={isOpen} onClose={() => setOpen(false)}>
        <VoteMomoModal
          onClose={() => setOpen(false)}
          combo={combo}
          missId={missId}
          payUrl={payUrl}
        />
      </Modal>

      <div className="modal-container">
        <Modal isOpen={isOpenPrice} onClose={() => setOpenPrice(false)}>
          <PriceModal onClose={() => setOpenPrice(false)} />
        </Modal>
      </div>
    </Styles>
  );
};

export default ContestantDetail;

const Styles = styled.div`
  .text-index {
    border: 1px dashed #cb8b28 !important;
    border-radius: 12px;
  }

  .total-vote {
    padding: 12px 20px;
    background: #212635;
    border-radius: 8px;
    margin-bottom: 16px;

    .vote-number-1 {
      color: #c49664;
      font-size: 28px;
      font-weight: 700;
      width: fit-content;
      background: linear-gradient(
        89.83deg,
        #c49664 0.16%,
        #feefa9 50.01%,
        #c89a66 99.86%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .vote-number-2 {
      color: #a5bfd7;

      span {
        color: white;
        font-size: 18px;
        font-weight: 700;
      }
    }
  }

  .contestant-name {
    font-size: 40px;
    font-weight: 700;
    text-transform: uppercase;
    margin: 8px 0 24px;
  }

  .sub-text {
    color: #838d9a;
    font-weight: 700;
  }

  .content-text {
    margin: 8px 0 16px;
  }

  .video-content {
    padding-bottom: 0 !important;
    img {
      border-radius: 12px;
    }
  }

  .info {
    background-color: #212635;
    border-radius: 8px;
    padding: 12px 16px;
  }

  .info-item {
    margin-bottom: 8px;
    span {
      color: #838d9a;
      margin-right: 4px;
    }
  }

  .detail-button {
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* align-items: center; */
    gap: 16px;
    margin-top: 24px;

    button {
      white-space: nowrap;
      border-radius: 12px;
    }
  }

  .index__desc {
    font-size: 18px;
    text-transform: initial !important;
    font-weight: 500;
    .title {
      color: #807b88;
      font-size: 16px;
      font-weight: 400;
      text-transform: initial;
    }
  }

  @media only screen and (max-width: 1199px) {
    .detail-button {
      button {
        white-space: unset;
      }
    }
  }
`;
